import { render, staticRenderFns } from "./PromotionDetailsCard.vue?vue&type=template&id=fd177ba4&"
import script from "./PromotionDetailsCard.vue?vue&type=script&lang=js&"
export * from "./PromotionDetailsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports